export class Config {

  //100% static
  static wp_home = "/#/landing";
  static wp_becameanhost = "/#/landing";
  static wp_termsandconditions = " http://gamechangers.bbyo.org/terms-and-conditions";
  static wp_onetable = "http://onetable.org";
  static wp_locations = "http://gamechangers.bbyo.org/debate-nights";

  static linkHash = "#";
  static home = "/landing";
  static error = "/error/";
  static manage = "/manage";
  static events = "/events";
  static profile = "/profile";
  static hostPromotion = "/host/promote";
  static upcoming = "upcoming";
  static hosted = "hosted";
  static saved = "saved";
  static past = "past";
  static reservations = "reservations";
  static payments = "payments";
  static suggested = "suggested";
  static sponsors = "sponsors";

  //error config
  static tokenError = "reset_password_token";
  static minCharError = "password";


  //Opinionable
  static localStorageToken = "access_token";
  static localStorageTokenType = "token_type";
  static localStorageRefreshToken = "refresh_token";

  //Utilyties
  static utilities = "/utilities";
  static cards = "/cards";
  static coupon = "/coupons/code";


  //from config.json
  static apiEndpoint;
  static publicEndpoint;

  static productionMode;
  static isOnward;


  //built from json data
  static tokenEndpoint;
  static tokenSocialEndpoint;

  static usersEndpoint;

  static profileEndpoint;
  static updatePasswordEndpoint;

  static eventsEndpoint;
  static dashboardEventsEndpoint;
  static reservationsEndpoint;
  static hostRequestEndpoint;
  static newUploadEndpoint;
  static resetPasswordEndpoint;

  static controlPanelEndpoint;

  static areasEndpoint;
  static timezoneEndpoint;
  static cardsEndpoint;
  static couponEndpoint;

  static facebookAppId;
  static stripePublishableKey;
  static amazonUrl;
  static googleKey;


  static load(jsonConfig) {
    //from config.json
    Config.facebookAppId = jsonConfig.facebookAppId;
    Config.stripePublishableKey = jsonConfig.stripePublishableKey;
    Config.amazonUrl = jsonConfig.amazonUrl;
    Config.publicEndpoint = jsonConfig.publicEndpoint;
    Config.googleKey = jsonConfig.googleKey;


    Config.productionMode = jsonConfig.production;
    Config.isOnward = !!jsonConfig.isOnward;

    Config.apiEndpoint = jsonConfig.apiEndpoint;
    Config.controlPanelEndpoint = Config.apiEndpoint + "../../../cp";

    //built from json data
    Config.tokenEndpoint = Config.apiEndpoint + "/../../oauth/token";
    Config.tokenSocialEndpoint = Config.apiEndpoint + "/../../tokens/social";

    Config.usersEndpoint = Config.apiEndpoint + "/../../users";
    Config.resetPasswordEndpoint = Config.apiEndpoint + "/../../users/password";
    Config.profileEndpoint = Config.apiEndpoint + "/profile";
    Config.updatePasswordEndpoint = Config.apiEndpoint + "/profile/password";

    Config.eventsEndpoint = Config.apiEndpoint + "/events";
    Config.reservationsEndpoint = Config.apiEndpoint + "/reservations";
    Config.dashboardEventsEndpoint = Config.apiEndpoint + "/dashboard/events";
    Config.hostRequestEndpoint = Config.apiEndpoint + "/profile/host_request";

    Config.newUploadEndpoint = Config.apiEndpoint + "/uploads/new";
    Config.areasEndpoint = Config.apiEndpoint + "/areas";
    Config.timezoneEndpoint = Config.apiEndpoint + Config.utilities + "/timezones";
    Config.cardsEndpoint = Config.apiEndpoint + Config.cards;
    Config.couponEndpoint = Config.apiEndpoint + Config.coupon;
  }
}



/** WEBPACK FOOTER **
 ** ./src/scripts/config.ts
 **/